<template>
    <div>
        <div class="row gutter-sm">
            <div class="col-xs-12 col-sm-12">
                <span class="q-headline text-weight-light">{{ $t('user_data') }}</span>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="user_full_name" :float-label="$t('name')" disable/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="user_email" :float-label="$t('email')" disable/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="reward_level_title" :float-label="$t('level')" disable/>
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-input v-model="total_earned_points" :float-label="$t('total_points')" disable/>
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-input v-model="user_current_points" :float-label="$t('points_for_use')" disable/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date, debounce } from 'quasar'
const { formatDate } = date

export default {
    props:['data', 'id'],

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            reward_levels: 'registration_lists/reward_levels',
            id_user_language_selected: 'common/id_user_language_selected',
            user_clients_store: 'common/user_clients',
            id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        user_email: {
            get() {
              return this.data.user_email
            },
            set() {

            }
        },

        user_full_name: {
            get() {
                return this.data.user_full_name
            },
            set() {

            }
        },

        reward_level_title: {
            get() {
                return this.data.reward_level_title
            },
            set() {

            }
        },

        total_earned_points: {
            get() {
                return this.data.total_earned_points
            },
            set() {

            }
        },

        user_current_points: {
            get() {
                return this.data.user_current_points
            },
            set() {

            }
        }
    },

    methods: {
        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },
    },
}
</script>

<style>

</style>